module.exports = __webpack_public_path__ + "img/arinalisaeriyn-55d60a9a-a660-434a-9ba4-08d94053bf76.png";